import {FactoryID} from "../../model-factory/type-interface/ModelFactoryType";
import {IPopulateIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import ApiRequestVO from "../../manager/api/ApiRequestVO";
import {IAnyObject} from "../../common/SimpleInterface";
import ApiError from "../../manager/api/ApiError";
import {LocateDataModel, LocateSearchParams, LocateReturnType} from "./LocateDataFactory";
import {getModelFactory} from "../../model-factory/ModelFactory";
import SearchPageListDataFactory, {SearchPageBasicDataModel} from "../search/SearchPageBasicDataFactory";

export class LocatePageListDataModel extends SearchPageBasicDataModel
{

    searchParams:LocateSearchParams = new LocateSearchParams();

    onModelConditionsApplied()
    {
        super.onModelConditionsApplied();
        this.requirePages();
    }

    resetChoiceList(): void
    {
        super.resetChoiceList();
        this.requirePages();
    }

    getPopulateRequestVO(): ApiRequestVO|null
    {
        if(!this.searchParams.searchTermID){
            return null;
        }

        const requestVO = new ApiRequestVO(true);
        if(!this.searchParams.organisationID){
            requestVO.endpoint = "/post/"+this.searchParams.postType+"/count";
        } else {
            requestVO.endpoint = "/post/organisation/"+this.searchParams.organisationID+"/"+this.searchParams.postType+"/count";
        }
        requestVO.params = {
            by_distance: this.searchParams.sortBy === "distance",
            search_term: encodeURIComponent(this.searchParams.searchTerm),
            country_code: this.searchParams.countryCode,
            latitude: this.searchParams.latitude,
            longitude: this.searchParams.longitude,
            require_location: this.searchParams.requireLocation
        }

        return requestVO;
    }

    populateWithRequestResponse(response: IAnyObject, replaceData:boolean): ApiError | null
    {
        let error =  super.populateWithRequestResponse(response, replaceData);
        if(error){
            return error;
        }
        this.numberOfEntries = response.count && !isNaN(response.count) ? parseInt(response.count) : 0;
        this.actualPageCount = this.numberOfEntries > 0 ? Math.ceil(this.numberOfEntries / this.entryLimit) : 0;
        this.requirePages();
        return null;
    }

    requirePages()
    {
        const pageCount = Math.max(this.actualPageCount, 1);

        let pageObjects:IAnyObject[] = [];
        for(let i = 0; i < pageCount; i ++)
        {
            const pageNumber = i + 1;
            pageObjects.push({
                id: pageNumber,
                name: pageNumber
            });

        }

        this.populateChoiceList(pageObjects, true);
    }


    getChildModel(pageNumber?:number, returnType?:LocateReturnType): LocateDataModel|null
    {
        pageNumber = pageNumber ? pageNumber : 1;
        if(pageNumber < 1 || pageNumber > this.choiceOrder.length){
            return null
        }
        returnType = returnType ?? "object";
        return getModelFactory().locateData.getLocateDataModel(
            this.searchParams,
            pageNumber,
            returnType
        )
    }

    getChildModels(returnType?:LocateReturnType): LocateDataModel[]
    {
        const models:LocateDataModel[] = [];
        for(let i = 0; i < this.choiceOrder.length; i ++){
            const pageNumber = i + 1;
            models.push(this.getChildModel(pageNumber, returnType)!);
        }
        return models;
    }
}

export default class LocatePageListDataFactory extends SearchPageListDataFactory
{

    id: FactoryID = "locate_page_list_data";

    birth(id: string): LocatePageListDataModel
    {
        return new LocatePageListDataModel(id);
    }

    getLocatePageListDataModel(searchParams:LocateSearchParams): LocatePageListDataModel
    {
        const populateIDs:IPopulateIDs = {
            post_type: searchParams.postType ?? undefined,
            search_sort_by: searchParams.sortBy,
        };
        if(searchParams.searchTermID){
            populateIDs.search_term_id = searchParams.searchTermID;
        }
        if(searchParams.countryCode)
        {
            populateIDs.locate_country_code = searchParams.countryCode;
        }
        if(searchParams.latitude || searchParams.longitude)
        {
            populateIDs.locate_latitude = searchParams.latitude;
            populateIDs.locate_longitude = searchParams.longitude;
        }
        if(searchParams.requireLocation)
        {
            populateIDs.locate_require_location = true;
        }
        return this.requireModel(populateIDs) as LocatePageListDataModel;
    }
}